import { render, staticRenderFns } from "./GeneralSettings.vue?vue&type=template&id=668a46fc&"
import script from "./GeneralSettings.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettings.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports